import { gql } from '@apollo/client'

export const GET_URLS = gql`
  query GetUrls {
    urls @client {
      last
    }
  }
`
